export default __webpack_public_path__ + "static/media/pig.e1e49f1e.png";